import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import PaymentModel from "../../model/PaymentModel";

export class PageDopInfoStore {
    private rootStore: RootStore | undefined;
    arElement = {}
    clientId: number | undefined = 0;


    public error: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
        this.clientId = this.rootStore?.mainStore.getClientId();
        PaymentModel.getDiscounts(Number(this.clientId), this.setElement, this.setError);
    }



    @action
    setElement = (result: any) => {
        if (result.data){
            let upperBound = result.data[0].user_get_discounts_list.trademarks.length;
            for (let i =0 ; i< upperBound ; i++){
                if (result.data[0].user_get_discounts_list.trademarks[i].picture.length === 0){
                    result.data[0].user_get_discounts_list.trademarks.push(result.data[0].user_get_discounts_list.trademarks[i]);
                    result.data[0].user_get_discounts_list.trademarks.splice(i, 1);
                    upperBound--;
                    i--;
                }
            }
            this.arElement = result.data[0].user_get_discounts_list;
        }
    }

    @action
    setError = (error: any) => {
        console.log(error);
    }

}